import api from "./axiosInstance";

export const getInvitations = async () => {
  const res = await api.get("api/v1/invitations/");
  return res.data;
};

export const getInvitationsByEventId = async (limit = 10, offset = 0, eventId) => {
  const res = await api.get(`api/v1/invitations/?event=${eventId}&limit=${limit}&offset=${offset}`);
  return res.data;
};

export const sendInvitation = async (payload) => {
  const res = await api.post(`api/v1/invitations/`, payload);
  return res.data;
};

export const cancelInvitation = async (id) => {
  await api.post(`api/v1/invitations/${id}/cancel/`);
};
